import { SelectedTeamContext } from "@/context/SelectedTeamContext";
import React from "react";

export default function useSelectedTeam() {
  return React.useContext(SelectedTeamContext);
}
